import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Calendar, Users, Building2, Image as ImageIcon, BookOpen, Brain, FileText, Sparkles, LogOut, Crown } from "lucide-react";
import { useAdminAuth } from "../auth/AdminAuthContext";

const NAV_ITEMS = [
  { to: "/admin/nail-events", icon: Calendar, vi: "Sự kiện", en: "Events" },
  { to: "/admin/library/speakers", icon: Users, vi: "Diễn giả", en: "Speakers" },
  { to: "/admin/board", icon: Crown, vi: "Hội đồng QT", en: "Board" },
  { to: "/admin/library/sponsors", icon: Building2, vi: "Tài trợ", en: "Sponsors" },
  { to: "/admin/library/media", icon: ImageIcon, vi: "Media", en: "Media" },
  { to: "/admin/library/knowledge", icon: BookOpen, vi: "Tri thức", en: "Knowledge" },
  { to: "/admin/library/ai", icon: Brain, vi: "Bộ Não AI", en: "AI Brain" },
  { to: "/admin/library/articles", icon: FileText, vi: "Bài viết", en: "Articles" },
  { to: "/admin/training", icon: Sparkles, vi: "Huấn luyện", en: "Training" },
];

export default function AdminMobileNav({ lang = "vi", className = "" }) {
  const [open, setOpen] = useState(false);
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    setOpen(false);
    navigate("/admin/login", { replace: true });
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="admin-mobile-nav-open"
        className={`md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full bg-espresso text-linen hover:bg-espresso-hover transition ${className}`}
        aria-label="Open admin menu"
      >
        <Menu className="w-4 h-4" />
      </button>

      {open && (
        <div className="fixed inset-0 z-[70] bg-charcoal/50 backdrop-blur-sm md:hidden" onClick={() => setOpen(false)} data-testid="admin-mobile-nav-overlay">
          <aside
            onClick={(e) => e.stopPropagation()}
            className="absolute right-0 top-0 bottom-0 w-[85%] max-w-sm bg-white shadow-[-30px_0_60px_-30px_rgba(0,0,0,0.4)] flex flex-col"
            data-testid="admin-mobile-nav-sheet"
          >
            <div className="px-5 py-4 border-b border-espresso/10 flex items-center justify-between">
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-[0.24em] text-espresso-muted font-semibold">Admin</p>
                <p className="font-serif text-lg text-espresso truncate">{admin?.email || "—"}</p>
              </div>
              <button type="button" onClick={() => setOpen(false)} data-testid="admin-mobile-nav-close" className="p-2 text-espresso-muted hover:text-espresso">
                <X className="w-5 h-5" />
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto px-3 py-4">
              {NAV_ITEMS.map(({ to, icon: Icon, vi, en }) => (
                <Link
                  key={to}
                  to={to}
                  onClick={() => setOpen(false)}
                  data-testid={`admin-mobile-nav-${to.split("/").pop()}`}
                  className="flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium text-espresso hover:bg-linen-100"
                >
                  <Icon className="w-4 h-4 text-espresso-muted" />
                  <span>{lang === "en" ? en : vi}</span>
                </Link>
              ))}
            </nav>
            <div className="border-t border-espresso/10 p-3">
              <button
                type="button"
                onClick={onLogout}
                data-testid="admin-mobile-nav-logout"
                className="w-full inline-flex items-center justify-center gap-2 bg-warmgray-100 text-espresso rounded-xl px-3 py-3 text-sm font-medium hover:bg-warmgray-200"
              >
                <LogOut className="w-4 h-4" /> {lang === "en" ? "Sign out" : "Đăng xuất"}
              </button>
            </div>
          </aside>
        </div>
      )}
    </>
  );
}
